export type ScrollDirection = -1 | 0 | 1;

export interface ScrollMotion {
  readonly velocity: number;
  readonly direction: ScrollDirection;
  readonly intensity: number;
}

const IDLE_SCROLL_MOTION: ScrollMotion = {
  velocity: 0,
  direction: 0,
  intensity: 0,
};

let currentScrollMotion: ScrollMotion = IDLE_SCROLL_MOTION;

export function updateScrollMotion(
  velocity: number,
  direction: ScrollDirection,
): void {
  currentScrollMotion = {
    velocity,
    direction,
    intensity: Math.min(1, Math.abs(velocity) / 18),
  };
}

export function readScrollMotion(): ScrollMotion {
  return currentScrollMotion;
}

export function resetScrollMotion(): void {
  currentScrollMotion = IDLE_SCROLL_MOTION;
}
